import { render, staticRenderFns } from "./excellentEnterpriserEcommend.vue?vue&type=template&id=5657f7ba&scoped=true"
import script from "./excellentEnterpriserEcommend.vue?vue&type=script&lang=js"
export * from "./excellentEnterpriserEcommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5657f7ba",
  null
  
)

export default component.exports